import React, { useState, useEffect, useRef } from 'react';
import { X, Plus, Trash2, Calendar, Send, Mail, MessageSquare, Tag, Phone, AlertCircle, ArrowLeft, Clock } from 'lucide-react';
import { getSession } from '../../../getSession';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import EnquiryActionOperation from './EnquiryActionOperation';
import InternationalSMSForm from '../Forms/InternationalSMSForm';
import Loader from '../../../components/Loader/Loader';
import Alert from '../../../common/Alerts/Alert';
import './EnquiryMassoperation.css';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { bindSourceMediumCampaign } from '../../../utils/lead';

// Safe wrapper for ReactQuill to avoid concurrent rendering issues
const SafeQuill = React.memo(React.forwardRef((props, ref) => {
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => { setMounted(true); }, []);
    if (!mounted) return <div className="quill-editor-wrap" style={{ minHeight: 200 }} />;
    return <ReactQuill ref={ref} {...props} />;
}));

const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'align': [] }],
        [{ 'header': [1, 2, 3, false] }],
        ['link', 'image'],
        ['clean']
    ]
};

const EnquiryMassoperation = ({
    mode,
    selectedEnquiries,
    isAllSelectedAcrossPages,
    totalRecord,
    onBack,
    onSuccess
}) => {
    const { userId, TokenId, parentId } = getSession();
    const TOKEN = TokenId || API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN;
    const SESSION_USER_ID = userId || localStorage.getItem('UserId') || '34594';
    const WCF_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const API_BASE_SERVICES = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const LOCAL_BASE_URL = (process.env.REACT_APP_LOCAL_DEVELOPMENT_URL || '').replace(/\/$/, '');
    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');


    // API Endpoints
    const SERVICE_AZURE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const Bind_Mass_Update = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.MASS_UPDATE_BIND_FIELD}`;
    const Mass_Update_Save = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.MASS_UPDATE_SAVE}`;
    // const Get_Stage_List = `${API_BASE_SERVICES}${API_ENDPOINTS.ENQUIRIES.GET_STAGE_LIST}`;
    // Core Mass Update States
    const [fields, setFields] = useState([]);
    const [selectedField, setSelectedField] = useState('');
    const [fieldValue, setFieldValue] = useState('');
    const [addedUpdates, setAddedUpdates] = useState([]);
    const [isScheduled, setIsScheduled] = useState(false);
    const [scheduleDateTime, setScheduleDateTime] = useState(() => {
        const now = new Date();
        const offset = now.getTimezoneOffset() * 60000;
        return new Date(now - offset).toISOString().slice(0, 16);
    });
    const [isLoading, setIsLoading] = useState(false);
    const [alertConfig, setAlertConfig] = useState({ show: false, type: 'success', title: '', message: '', onConfirm: null });

    // Track SMS States
    const [shortUrls, setShortUrls] = useState([]);
    const [showTrackDetails, setShowTrackDetails] = useState(false);
    const [showMailPreview, setShowMailPreview] = useState(false);
    const [trackForm, setTrackForm] = useState({
        Domain: '',
        TrackUrl: '',
        Action: 'original',
        MobileNo: '',
        EmailId: '',
        Subject: '',
        Body: '',
        WhatsappNo: '',
        Message: ''
    });

    // States for Options
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [sources, setSources] = useState([]);
    const [mediums, setMediums] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [owners, setOwners] = useState([]);
    const [stages, setStages] = useState([]);
    const [sequences, setSequences] = useState([]);
    const [selectedSequence, setSelectedSequence] = useState('');
    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState('');
    const [isCustomTag, setIsCustomTag] = useState(false);

    // States for dependent selections
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');

    // Call List States
    const [callLists, setCallLists] = useState([]);
    const [selectedCallList, setSelectedCallList] = useState('');
    const [scheduleType, setScheduleType] = useState('anytime'); // 'specific', 'none', 'anytime'
    const [specificDateTime, setSpecificDateTime] = useState('');
    const [anyTimeDate, setAnyTimeDate] = useState(() => new Date().toISOString().slice(0, 10));

    // API Endpoints from AddEnquiryForm

    const Get_country = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetCountry`;
    const Get_State = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetStateByCountry`;
    const Get_city_By_State = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetCityByState`;
    

    const Get_Stage_List = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_STAGE_LIST}`;
    const Get_Marketing_Sequence = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_MARKETING_SEQUENCE}`;
    const Save_Mass_Sequence = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.SAVE_MASS_SEQUENCE}`;
    const Collabrator = `${SERVICE_AZURE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;

  const Internation_Sms_ID_Conversion = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.MASS_INTERNATIONAL_SMS_ID_CONVERSION}`;
  const Use_Auth = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.USE_AUTH}`;
  const Add_Remove_Tags = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.ADD_REMOVE_TAGS}`;
  const Get_Tag_List = `${SERVICE_AZURE_URL}/UserCRM/GetAllSegmentList`;
  const Save_Call_List = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.ADD_CALL_LIST_SAVE}`;
  const Get_Call_List_Options = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_SCHEDULE_CALL_ACTION}`;
  const Save_Mass_Followup = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.SAVE_MASS_FOLLOWUP}`;
   const Send_Mass_SMS = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.SEND_MASS_SMS}`;
  const FOLLOWUP_STATUS_URL = `${SERVICE_AZURE_URL}${API_ENDPOINTS.APPOINTMENTS.FOLLOWUPSTATUS_LIST}`;
  const USER_HIERARCHY_URL = `${API_BASE_SERVICES}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
   const PRODUCT_SUGGESTION = `${SERVICE_AZURE_URL}/${API_ENDPOINTS.APPOINTMENTS.PRODUCT_SUGGESTION_FOR_FOLLOWUP}`;
   const GET_MAIL_SMS_DLT_ACCOUNT = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.GET_MAIL_SMS_DLT_ACCOUNT}`;
   const SENDERID = `${SERVICE_AZURE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_SENDER_IDFOR_SMS}`;
   const Template_for_main = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.NEW_GET_TEMPLATE_FOR_MAIL}`;
   const Send_mail_New = `${NEWV3_BASE_URL}${API_ENDPOINTS.ENQUIRIES.SEND_MAIL_NEW}`;
   const FROM_MAIL_IDS = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.NEW_GET_FROM_MAIL_ID}`;
   const GET_MAIL_SUBJECT_FROM_TEMPLATE = `${SERVICE_AZURE_URL}${API_ENDPOINTS.COMMON.GET_MAIL_SUBJECT_FROM_TEMPLATE}`;
   const Get_Short_Url= `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_SHORT_URL}`;
   const Template_for_mail_SMS_NEW = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_TEMPLATE_NEW}`;
   const Template_for_mail_SMS_Details = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.GET_TEMPLATE_DETAILS}`;
  // Followup States
  const [followupStatusOptions, setFollowupStatusOptions] = useState([]);
  const [followupData, setFollowupData] = useState({
      FollowupStatus: '',
      AssignTo: SESSION_USER_ID,
      NextStatusDate: new Date().toISOString().split('T')[0],
      NextStatusTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
      AmountPaid: '',
      Remarks: '',
      Products: '',
      IsReassign: false,
      OnSchedule: false,
      ScheduleDateTime: new Date().toISOString().slice(0, 16)
  });

    // Mail States
    const [mailAccounts, setMailAccounts] = useState([]);
    const [fromMailOptions, setFromMailOptions] = useState([]);
    const [mailTemplates, setMailTemplates] = useState([]);
    const [sendMailData, setSendMailData] = useState({
        Email1: true,
        Email2: true,
        Email3: false,
        Account: '',
        From: '',
        ReplyTo: '',
        SenderName: '',
        MailMode: 'template',
        Subject: '',
        TemplateId: '',
        TemplateName: '',
        Body: '',
        OnSchedule: false,
        ScheduleDateTime: new Date().toISOString().slice(0, 16)
    });

    // Product Suggestion States
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [suggestedProducts, setSuggestedProducts] = useState([]);
    const [showProductDropdown, setShowProductDropdown] = useState(false);
    const [selectedLocalProducts, setSelectedLocalProducts] = useState([]);
    const productSearchTimerRef = useRef(null);

    // SMS States
    const [smsAccounts, setSmsAccounts] = useState([]);
    const [smsSenderIds, setSmsSenderIds] = useState([]);
    const [smsTemplates, setSmsTemplates] = useState([]);
    const [isTrackSMSModalOpen, setIsTrackSMSModalOpen] = useState(false);
    const [sendSmsData, setSendSmsData] = useState({
        Account: '',
        SenderId: '',
        TemplateId: '',
        Message: '',
        IsUnicode: false,
        Mobile1: true,
        Mobile2: false,
        Mobile3: false,
        TrackUrl: false,
        TrackSms: false,
        OnSchedule: false,
        ScheduleDateTime: new Date().toISOString().slice(0, 16)
    });

    // Product search handler
    const handleProductSearch = (term) => {
        setProductSearchTerm(term);
        if (term.trim().length < 2) {
            setSuggestedProducts([]);
            setShowProductDropdown(false);
            if (productSearchTimerRef.current) clearTimeout(productSearchTimerRef.current);
            return;
        }

        if (productSearchTimerRef.current) clearTimeout(productSearchTimerRef.current);

        productSearchTimerRef.current = setTimeout(async () => {
            try {
                const response = await fetch(PRODUCT_SUGGESTION, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: TOKEN, Details: { UserId: Number(SESSION_USER_ID), Term: term } })
                });
                const result = await response.json();
                const products = result?.Details || result?.d || result?.data || [];
                setSuggestedProducts(products);
                setShowProductDropdown(products.length > 0);
            } catch (error) {
                console.error("Error fetching product suggestions:", error);
            }
        }, 500);
    };

    const handleSelectProduct = (p) => {
        const productVal = p.Value || p.ProductID || p.id || p.ID || p.Id;
        const productText = p.Text || p.ProductName || p.Name || p.name;

        if (!selectedLocalProducts.some(lp => lp.Value === productVal)) {
            setSelectedLocalProducts(prev => [...prev, { Value: productVal, Text: productText }]);
        }

        setProductSearchTerm('');
        setShowProductDropdown(false);
        setSuggestedProducts([]);
    };

    const handleRemoveProduct = (val) => {
        setSelectedLocalProducts(prev => prev.filter(p => p.Value !== val));
    };

    useEffect(() => {
        if (mode === 'update') {
            fetchFields();
            fetchInitialOptions();
        } else if (mode === 'marketing_sequence') {
            fetchSequences();
        } else if (mode === 'add_tag' || mode === 'remove_tag') {
            fetchTags();
        } else if (mode === 'add_call_list') {
            fetchCallListOptions();
        } else if (mode === 'add_followup') {
            fetchFollowupInitialData();
        } else if (mode === 'sms') {
            fetchSmsInitialData();
        } else if (mode === 'mail') {
            fetchMailInitialData();
        }
    }, [mode]);

    const fetchFollowupInitialData = async () => {
        setIsLoading(true);
        try {
            const [statusRes, userRes] = await Promise.all([
                fetch(FOLLOWUP_STATUS_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(SESSION_USER_ID) } })
                }),
                fetch(USER_HIERARCHY_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: TOKEN, Details: { UserId: parseInt(SESSION_USER_ID, 10) } })
                })
            ]);

            if (statusRes.ok) {
                const result = await statusRes.json();
                const data = result.Details || result.d || result.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch(e){} }
                setFollowupStatusOptions(Array.isArray(parsed) ? parsed : []);
            }
            if (userRes.ok) {
                const result = await userRes.json();
                const rawData = result.Details?.data || result.Details || result.d || result.data || result;
                let parsed = Array.isArray(rawData) ? rawData : [];
                if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch(e){} }
                const ownersList = Array.isArray(parsed) ? parsed : [];
                setOwners(ownersList);
                if (ownersList.length > 0) {
                    setFollowupData(prev => ({ ...prev, AssignTo: ownersList[0].Id || ownersList[0].Code || ownersList[0].User_ID || SESSION_USER_ID }));
                }
            }
        } catch (error) {
            console.error("Error fetching followup data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchSmsInitialData = async () => {
        setIsLoading(true);
        try {
            const [accRes, senderRes, tempRes] = await Promise.all([
                fetch(GET_MAIL_SMS_DLT_ACCOUNT, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "universal-token": TOKEN },
                    body: JSON.stringify({ Token: TOKEN, LoggedUserId: SESSION_USER_ID, Details: { ParentId: parseInt(SESSION_USER_ID, 10), isSMS: true } })
                }),
                fetch(SENDERID, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: TOKEN, Details: { UserId: parseInt(SESSION_USER_ID, 10) } })
                }),
                fetch(Template_for_main, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(SESSION_USER_ID), isSMS: 1, isMail: 0 } })
                })
            ]);

            if (accRes.ok) {
                const result = await accRes.json();
                let data = result.Details ?? result.data ?? result.d ?? result;
                if (data && typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { data = []; } }
                const finalAccounts = Array.isArray(data) ? data : (data.data || []);
                setSmsAccounts(finalAccounts);
                if (finalAccounts.length > 0) setSendSmsData(prev => ({ ...prev, Account: finalAccounts[0].AccountId || finalAccounts[0].Code }));
            }
            if (senderRes.ok) {
                const result = await senderRes.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) {
                    setSmsSenderIds(parsed);
                    if (parsed.length > 0) setSendSmsData(prev => ({ ...prev, SenderId: parsed[0].SenderName }));
                }
            }
            if (tempRes.ok) {
                const result = await tempRes.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) setSmsTemplates(parsed);
            }

            // Fetch Short URLs
            const shortUrlRes = await fetch(Get_Short_Url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Details: { Parentid: Number(SESSION_USER_ID) } })
            });
            if (shortUrlRes.ok) {
                const result = await shortUrlRes.json();
                setShortUrls(result.Details || []);
                if (result.Details?.length > 0) {
                    setTrackForm(prev => ({ ...prev, Domain: result.Details[0].shorturl }));
                }
            }
        } catch (error) {
            console.error("Error fetching SMS data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSmsChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSendSmsData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        if (name === 'TrackUrl' && !checked) {
            setShowTrackDetails(false);
        }
    };

    const handleTrackFormChange = (e) => {
        const { name, value } = e.target;
        setTrackForm(prev => ({ ...prev, [name]: value }));
    };

    const handleAddTrackUrl = () => {
        if (!trackForm.TrackUrl) {
            showAlert('error', 'Error', "Track URL is required");
            return;
        }

        let link = trackForm.TrackUrl;
        if (trackForm.Domain) {
            link = `${trackForm.Domain}/${link}`;
        }

        setSendSmsData(prev => ({
            ...prev,
            Message: prev.Message + " " + link
        }));

        setShowTrackDetails(false);
    };

    const handleSendMassSms = async () => {
        if (!sendSmsData.Account || !sendSmsData.SenderId || !sendSmsData.Message) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }

        setIsLoading(true);
        try {
            const ids = selectedEnquiries.join(',');
            const currentDateTime = new Date().toISOString().replace('T', ' ').slice(0, 19);
            const scheduleDateTimeFormatted = sendSmsData.OnSchedule ? sendSmsData.ScheduleDateTime.replace('T', ' ') + ':00' : currentDateTime;

            const smsItem = {
                IDS: ids,
                AccountID: Number(sendSmsData.Account),
                SenderID: sendSmsData.SenderId,
                Message: sendSmsData.Message,
                IsUniCode: sendSmsData.IsUnicode,
                IsMobile: sendSmsData.Mobile1,
                IsMobile1: sendSmsData.Mobile2,
                IsMobile2: sendSmsData.Mobile3,
                TemplateID: sendSmsData.TemplateId || "0",
                sms_source: "CRM",
                smsDateTime: scheduleDateTimeFormatted
            };

            const payload = {
                Token: TOKEN,
                Details: {
                    massLeadSmses: [smsItem],
                    IDS: ids,
                    Userid: Number(SESSION_USER_ID),
                    massbatchid: 0,
                    Module: "Lead",
                    ModuleType: "BulkSMS",
                    StartDateTime: currentDateTime
                }
            };

            const response = await fetch(Send_Mass_SMS, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            if (result.Status === 1 || result.Status === "1") {
                const apiMsg = result.Details?.[0]?.Msg || result.Message || "Mass SMS sent successfully!";
                showAlert('success', result.Message || 'Success', apiMsg, () => {
                    onSuccess && onSuccess();
                });
            } else {
                showAlert('error', 'Error', result.Message || "Failed to send mass SMS");
            }
        } catch (error) {
            console.error("Error sending mass SMS:", error);
            showAlert('error', 'Error', "Network error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    const fetchMailInitialData = async () => {
        setIsLoading(true);
        try {
            const [accRes, fromRes, tempRes] = await Promise.all([
                fetch(GET_MAIL_SMS_DLT_ACCOUNT, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "universal-token": TOKEN },
                    body: JSON.stringify({ Token: TOKEN, LoggedUserId: SESSION_USER_ID, Details: { ParentId: parseInt(SESSION_USER_ID, 10), isSMS: false } })
                }),
                fetch(FROM_MAIL_IDS, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: TOKEN, Details: { UserId: parseInt(SESSION_USER_ID, 10) } })
                }),
                fetch(Template_for_main, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: TOKEN, Details: { ParentId: Number(SESSION_USER_ID), isSMS: 0, isMail: 1 } })
                })
            ]);

            if (accRes.ok) {
                const result = await accRes.json();
                let data = result.Details ?? result.data ?? result.d ?? result;
                if (data && typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { data = []; } }
                const finalAccounts = Array.isArray(data) ? data : (data.data || []);
                setMailAccounts(finalAccounts);
                if (finalAccounts.length > 0) setSendMailData(prev => ({ ...prev, Account: finalAccounts[0].AccountId || finalAccounts[0].Code }));
            }
            if (fromRes.ok) {
                const result = await fromRes.json();
                const data = result?.Details || result?.d || result?.data || result;
                if (Array.isArray(data)) {
                    setFromMailOptions(data);
                    if (data.length > 0) setSendMailData(prev => ({ ...prev, From: data[0].Value, ReplyTo: data[0].Value }));
                }
            }
            if (tempRes.ok) {
                const result = await tempRes.json();
                const data = result?.Details || result?.d || result?.data || result;
                let parsed = Array.isArray(data) ? data : [];
                if (data && typeof data === 'string') { try { parsed = JSON.parse(data); } catch (e) { } }
                if (Array.isArray(parsed)) setMailTemplates(parsed);
            }
        } catch (error) {
            console.error("Error fetching Mail data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchMailSubject = async (templateId) => {
        if (!templateId) return;
        try {
            const response = await fetch(GET_MAIL_SUBJECT_FROM_TEMPLATE, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: TOKEN, Details: { TemplateId: templateId } })
            });
            const result = await response.json();
            const subject = result?.Details || result?.d || result?.data || "";
            if (subject) setSendMailData(prev => ({ ...prev, Subject: subject }));
        } catch (error) { console.error("Error fetching mail subject:", error); }
    };

    const handleMailChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSendMailData(prev => {
            const newState = {
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            };
            if (name === 'MailMode' && value === 'compose') {
                newState.Body = '';
                newState.TemplateId = '';
            }
            return newState;
        });
    };

    const handleSendMassMail = async () => {
        if (!sendMailData.Account || !sendMailData.From || !sendMailData.Subject) {
            showAlert('error', 'Error', "Please fill all required fields marked with *");
            return;
        }

        setIsLoading(true);
        try {
            const ids = selectedEnquiries.join(',');
            const scheduleDateTimeFormatted = sendMailData.OnSchedule ? sendMailData.ScheduleDateTime.replace('T', ' ') + ':00' : new Date().toISOString().replace('T', ' ').slice(0, 19);

            const mailItem = {
                IDS: ids,
                AccountID: Number(sendMailData.Account),
                Subjects: sendMailData.Subject,
                ComposeMsg: sendMailData.MailMode === 'template' ? sendMailData.TemplateName : sendMailData.Body,
                TemplateID: Number(sendMailData.TemplateId) || 0,
                SenderName: sendMailData.SenderName || "",
                ReplyTo: sendMailData.ReplyTo || sendMailData.From,
                EmailId: sendMailData.Email1,
                EmailId1: sendMailData.Email2,
                EmailId2: sendMailData.Email3,
                FromMailID: sendMailData.From,
                EnquiryScheduleDateTime: scheduleDateTimeFormatted
            };

            const payload = {
                Token: TOKEN.toString(),
                Details: {
                    massLeadMails: [mailItem],
                    IDS: ids,
                    Userid: Number(SESSION_USER_ID),
                    massbatchid: 0,
                    IsComposeMail: true
                }
            };

            const response = await fetch(Send_mail_New, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            if (result.Status === 1 || result.Status === "1") {
                const apiMsg = result.Details?.[0]?.Msg || result.Message || "Mass Mail sent successfully!";
                showAlert('success', result.Message || 'Success', apiMsg, () => {
                    onSuccess && onSuccess();
                });
            } else {
                showAlert('error', 'Error', result.Message || "Failed to send mass mail");
            }
        } catch (error) {
            console.error("Error sending mass mail:", error);
            showAlert('error', 'Error', "Network error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    const handleFollowupChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFollowupData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSaveMassFollowup = async () => {
        if (followupData.FollowupStatus === '' || followupData.FollowupStatus === undefined) {
            showAlert('error', 'Error', "Please select a followup status");
            return;
        }

        const rawValue = followupData.FollowupStatus.toString();
        const valueParts = rawValue.split(',');
        const statusId = Number(valueParts[0]) || 0;

        // Use the second part of the comma-separated value (0 = negative, 1 = scheduled/positive)
        const isNegative = valueParts.length > 1 ? valueParts[1] === '0' : false;

        setIsLoading(true);
        try {
            const ids = selectedEnquiries.join(',');
            const formattedNextDate = `${followupData.NextStatusDate} ${followupData.NextStatusTime}:00`;

            const followupItem = {
                AssignTo: isNegative ? 0 : (Number(followupData.AssignTo) || Number(SESSION_USER_ID) || 0),
                FollowupStatus: statusId,
                NextStatusDate: isNegative ? "1900-01-01 00:00:00" : formattedNextDate,
                Products: isNegative ? "" : selectedLocalProducts.map(p => p.Value).join(','),
                AmountPaid: (isNegative || !followupData.AmountPaid) ? 0 : parseFloat(followupData.AmountPaid),
                Remarks: followupData.Remarks,
                IsReassign: isNegative ? 0 : (followupData.IsReassign ? 1 : 0)
            };

            const payload = {
                Token: TOKEN,
                Details: {
                    massAddFollowUps: [followupItem],
                    IDS: ids,
                    Userid: Number(SESSION_USER_ID),
                    ParentID: Number(parentId),
                    massbatchid: 0,
                    StartDateTime: new Date().toISOString().replace('T', ' ').slice(0, 19)
                }
            };

            const response = await fetch(Save_Mass_Followup, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            if (result.Status === 1 || result.Status === "1") {
                const successMsg = result.Details?.[0]?.Msg || result.Message || "Mass followup added successfully!";
                showAlert('success', 'Success', successMsg, () => {
                    onSuccess && onSuccess();
                });
            } else {
                showAlert('error', 'Error', result.Message || "Failed to add mass followup");
            }
        } catch (error) {
            console.error("Error saving mass followup:", error);
            showAlert('error', 'Error', "Network error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    const fetchCallListOptions = async () => {
        setIsLoading(true);
        try {
            const { userId, TokenId } = getSession();
            const payload = {
                Token: TokenId || TOKEN,
                Message: '',
                LoggedUserId: userId,
                MAC_Address: '',
                IP_Address: '',
                Details: { Mode: 'SELECT', Id: 0, SettingJSON: '', UserId: userId },
                BroadcastName: ''
            };
            const response = await fetch(Get_Call_List_Options, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const res = await response.json();
                let list = res.Details || res.d || [];

                const processList = (data) => {
                    if (Array.isArray(data)) {
                        return data.map(item => {
                            const id = item.Id ?? item.id ?? item.Code ?? item.Value ?? item.AppId ?? item.name;
                            const name = item.Text ?? item.Detail ?? item.Name ?? item.DisplayName ?? item.AppName ?? item.name ?? id;
                            return id ? { id: String(id), name: String(name) } : null;
                        }).filter(Boolean);
                    }
                    if (data && typeof data === 'object') {
                        const raw = data.Text ?? data.Detail ?? data.Code ?? '';
                        try {
                            const parsed = raw && typeof raw === 'string' ? JSON.parse(raw) : (raw || {});
                            if (parsed && Array.isArray(parsed.leftTabs)) {
                                return parsed.leftTabs.map(t => ({
                                    id: String(t.name ?? t.Name ?? t.id ?? t.Id),
                                    name: String(t.text ?? t.Text ?? t.name ?? t.Name)
                                })).filter(Boolean);
                            }
                        } catch (e) { }
                    }
                    return [];
                };

                const opts = processList(list);
                setCallLists(opts);
            }
        } catch (error) {
            console.error("Error fetching call list options:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveCallList = async () => {
        if (!selectedCallList) {
            showAlert('error', 'Required', 'Please select a call list');
            return;
        }

        setIsLoading(true);
        try {
            const { userId, TokenId } = getSession();

            // Format IDs
            let ids = "";
            if (isAllSelectedAcrossPages) {
                ids = "0";
            } else {
                ids = selectedEnquiries.map(enq => {
                    if (typeof enq === 'object' && enq !== null) {
                        return enq.EnquiryId || enq.enquiryId || enq.id;
                    }
                    return enq;
                }).filter(id => id).join('#');
            }

            if (!ids) {
                showAlert('error', 'Selection Required', 'Please select at least one enquiry.');
                setIsLoading(false);
                return;
            }

            const callListObj = callLists.find(c => String(c.id) === String(selectedCallList));

            const details = {
                IDS: ids,
                Userid: Number(userId),
                massbatchid: 0,
                StartDateTime: scheduleType === 'specific' ? specificDateTime.replace('T', ' ') + ':00' : "",
                ListName: callListObj?.name || "",
                ScheduleDates: scheduleType === 'anytime' ? anyTimeDate : "",
                DateType: "Standard",
                Mode: "lead"
            };

            const payload = {
                Token: TokenId || TOKEN,
                Details: details
            };

            const response = await fetch(Save_Call_List, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1 || result.d?.Status === 1 || result.success) {
                    const successMsg = result.Details?.[0]?.Msg || result.Message || result.d?.Message || 'Added to call list successfully';
                    showAlert('success', 'Success', successMsg, () => {
                        if (onSuccess) onSuccess();
                    });
                } else {
                    throw new Error(result.Message || result.d?.Message || "Failed to add to call list");
                }
            } else {
                throw new Error("Failed to add to call list");
            }
        } catch (error) {
            showAlert('error', 'Error', error.message || 'Failed to save call list');
        } finally {
            setIsLoading(false);
        }
    };

    const fetchTags = async () => {
        setIsLoading(true);
        try {
            const { userId } = getSession();
            const response = await fetch(Get_Tag_List, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { strFilter: "", strUserID: String(userId) } })
            });
            if (response.ok) {
                const data = await response.json();
                setTags(data.d || []);
            }
        } catch (error) {
            console.error("Error fetching tags:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchInitialOptions = async () => {
        try {
            const { userId, TokenId, parentId } = getSession();
            const currentToken = TokenId || TOKEN;
            const payloadOptions = {
                Token: currentToken,
                Message: "",
                LoggedUserId: userId ?? 0,
                MAC_Address: "",
                IP_Address: "102.16.32.189",
                BroadcastName: ""
            };

            const [sourceList, mediumList, campaignList, countryRes, ownerRes, stageRes] = await Promise.all([
                bindSourceMediumCampaign({ ...payloadOptions, Details: { Type: 'SourceName', Parentid: Number(parentId || 0) } }),
                bindSourceMediumCampaign({ ...payloadOptions, Details: { Type: 'MediumName', Parentid: Number(parentId || 0) } }),
                bindSourceMediumCampaign({ ...payloadOptions, Details: { Type: 'CampaignName', Parentid: Number(parentId || 0) } }),
                fetch(Get_country, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ Token: "-2295521862261168", Details: {} }) }),
                fetch(Collabrator, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ Token: currentToken, Details: { UserId: Number(parentId) } }) }),
                fetch(Get_Stage_List, { 
                    method: 'POST', 
                    headers: { 'Content-Type': 'application/json' }, 
                    body: JSON.stringify({ 
                        Details: "", 
                        IP_Address: "", 
                        LoggedUserId: userId, 
                        MAC_Address: "", 
                        Message: "", 
                        Token: currentToken 
                    }) 
                })
            ]);

            setSources(sourceList);
            setMediums(mediumList);
            setCampaigns(campaignList);
            if (countryRes.ok) { const res = await countryRes.json(); setCountries(res.d || res.Details || []); }
            if (ownerRes.ok) { 
                const res = await ownerRes.json(); 
                const rawUsers = res.Details?.data || res.Details || res.d || res;
                let parsed = Array.isArray(rawUsers) ? rawUsers : [];
                if (typeof rawUsers === 'string') { try { parsed = JSON.parse(rawUsers); } catch(e){} }
                setOwners(Array.isArray(parsed) ? parsed : []); 
            }
            if (stageRes.ok) { 
                const res = await stageRes.json(); 
                let stageData = res.d || res.Details || [];
                if (typeof stageData === 'string') {
                    try {
                        stageData = JSON.parse(stageData);
                    } catch (e) {
                        console.error("Error parsing stages JSON:", e);
                        stageData = [];
                    }
                }
                setStages(Array.isArray(stageData) ? stageData : []);
            }
        } catch (error) { console.error("Error fetching options:", error); }
    };

    const fetchSequences = async () => {
        setIsLoading(true);
        try {
            const { userId, TokenId } = getSession();
            const payload = {
                Token: TokenId || TOKEN,
                Details: JSON.stringify({ UserId: Number(userId), Entity: "Enquiry" })
            };
            const response = await fetch(Get_Marketing_Sequence, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const res = await response.json();
                let data = res.d || res.Details || [];
                if (typeof data === 'string') {
                    try { data = JSON.parse(data); } catch (e) { }
                }
                setSequences(Array.isArray(data) ? data : []);
            }
        } catch (error) {
            console.error("Error fetching sequences:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveSequence = async () => {
        if (!selectedSequence) {
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Required',
                message: 'Please select a sequence'
            });
            return;
        }

        setIsLoading(true);
        try {
            const { userId, TokenId } = getSession();

            // Map IDs based on selection mode
            let ids = "";
            if (isAllSelectedAcrossPages) {
                ids = "0";
            } else if (selectedEnquiries && selectedEnquiries.length > 0) {
                // selectedEnquiries is an array of IDs (strings/numbers) based on EnquiryTable.jsx
                ids = selectedEnquiries.map(enq => {
                    if (typeof enq === 'object' && enq !== null) {
                        return enq.EnquiryId || enq.enquiryId || enq.id;
                    }
                    return enq;
                }).filter(id => id).join('#');
            }

            if (!ids) {
                setAlertConfig({
                    show: true,
                    type: 'error',
                    title: 'Selection Required',
                    message: 'Please select at least one enquiry to apply the sequence.'
                });
                setIsLoading(false);
                return;
            }

            const sequenceObj = sequences.find(s => String(s.SequenceID) === String(selectedSequence));

            const details = {
                IDS: ids,
                Userid: Number(userId),
                massbatchid: 0,
                SequenceId: Number(selectedSequence),
                SequenceName: sequenceObj?.SequenceName || "",
                StartDateTime: isScheduled ? scheduleDateTime.replace('T', ' ') + ':00' : "",
                SequenceType: "Lead"
            };

            const payload = {
                Token: TokenId || TOKEN,
                Details: JSON.stringify(details)
            };

            const response = await fetch(Save_Mass_Sequence, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setAlertConfig({
                    show: true,
                    type: 'success',
                    title: 'Success',
                    message: 'Sequence applied successfully',
                    onConfirm: () => onSuccess()
                });
            } else {
                throw new Error("Failed to save sequence");
            }
        } catch (error) {
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Error',
                message: error.message || 'Failed to save sequence'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveTag = async () => {
        setIsLoading(true);
        try {
            const { userId, TokenId } = getSession();

            // Format IDs
            let ids = "";
            if (isAllSelectedAcrossPages) {
                ids = "0";
            } else {
                ids = selectedEnquiries.map(enq => {
                    if (typeof enq === 'object' && enq !== null) {
                        return enq.EnquiryId || enq.enquiryId || enq.id;
                    }
                    return enq;
                }).filter(id => id).join(',');
            }

            if (!ids) {
                setAlertConfig({ show: true, type: 'error', title: 'Error', message: 'No enquiries selected.' });
                setIsLoading(false);
                return;
            }

            const payload = {
                Token: TokenId || TOKEN,
                Details: {
                    objMassTag: {
                        EnquiryIds: ids,
                        Tags: selectedTag,
                        ScheduledDateTime: isScheduled ? scheduleDateTime.replace('T', ' ') + ':00' : "",
                        UserId: Number(userId),
                        BatchId: 0
                    }
                }
            };

            if (mode === 'remove_tag') {
                payload.Details.objMassTag.ActionType = "Remove Tag";
            }

            const response = await fetch(Add_Remove_Tags, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            if (response.ok && (result.Status === 1 || result.d?.Status === 1)) {
                setAlertConfig({
                    show: true,
                    type: 'success',
                    title: 'Success',
                    message: `Tags ${mode === 'add_tag' ? 'added' : 'removed'} successfully.`,
                    onConfirm: () => {
                        if (onSuccess) onSuccess();
                    }
                });
            } else {
                setAlertConfig({
                    show: true,
                    type: 'error',
                    title: 'Error',
                    message: result.Message || result.d?.Message || `Failed to ${mode === 'add_tag' ? 'add' : 'remove'} tags.`
                });
            }
        } catch (error) {
            console.error("Error saving tags:", error);
            setAlertConfig({ show: true, type: 'error', title: 'Error', message: 'An error occurred while saving tags.' });
        } finally {
            setIsLoading(false);
        }
    };

    const handleCountryChange = async (countryId) => {
        setSelectedCountry(countryId);
        setSelectedState('');
        setFieldValue('');
        setStates([]);
        setCities([]);
        if (!countryId) return;
        try {
            const res = await fetch(Get_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(String(countryId), 10) } })
            });
            if (res.ok) { const data = await res.json(); setStates(data.d || data.Details || []); }
        } catch (error) { console.error("Error fetching states:", error); }
    };

    const handleStateChange = async (stateId) => {
        setSelectedState(stateId);
        setFieldValue('');
        setCities([]);
        if (!stateId) return;
        try {
            const res = await fetch(Get_city_By_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(String(stateId), 10) } })
            });
            if (res.ok) { const data = await res.json(); setCities(data.d || data.Details || []); }
        } catch (error) { console.error("Error fetching cities:", error); }
    };

    const formatDateDisplay = (dateStr, includeTime = true) => {
        if (!dateStr) return '';
        try {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr;
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const dd = String(date.getDate()).padStart(2, '0');
            const mmm = months[date.getMonth()];
            const yyyy = date.getFullYear();
            const hh = String(date.getHours()).padStart(2, '0');
            const mm = String(date.getMinutes()).padStart(2, '0');
            return includeTime ? `${dd}-${mmm}-${yyyy} ${hh}:${mm}` : `${dd}-${mmm}-${yyyy}`;
        } catch (e) {
            return dateStr;
        }
    };

    const fetchFields = async () => {
        setIsLoading(true);
        try {
            const payload = {
                Token: TOKEN || "-2295521862261168",
                Details: {
                    TableName: "Enquiry",
                    UserId: Number(SESSION_USER_ID)
                }
            };
            const response = await fetch(Bind_Mass_Update, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const result = await response.json();
                let data = result.d || result.Details || result;

                if (typeof data === 'string') {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {
                        console.error("Error parsing fields JSON:", e);
                        data = [];
                    }
                }

                setFields(Array.isArray(data) ? data : []);
            }
        } catch (error) {
            console.error("Error fetching fields for mass update:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleAddField = () => {
        if (!selectedField) {
            showAlert('error', 'Error', 'Please select a field');
            return;
        }
        if (!fieldValue) {
            showAlert('error', 'Error', 'Please enter or select a value');
            return;
        }

        const fieldObj = fields.find(f => f.FieldID === selectedField || f.FieldName === selectedField || f.fieldID === selectedField);

        if (addedUpdates.some(u => u.fieldID === (fieldObj?.FieldID || selectedField))) {
            showAlert('error', 'Error', 'This field is already added');
            return;
        }

        const displayValueMapping = () => {
            if (selectedField === 'Country') {
                return countries.find(c => String(c.Id || c.Value) === String(fieldValue))?.Value || countries.find(c => String(c.Value) === String(fieldValue))?.Text || fieldValue;
            } else if (selectedField === 'State') {
                return states.find(s => String(s.Id || s.Value) === String(fieldValue))?.Value || states.find(s => String(s.Value) === String(fieldValue))?.Text || fieldValue;
            } else if (selectedField === 'City') {
                return cities.find(c => String(c.Id || c.Value) === String(fieldValue))?.Value || cities.find(c => String(c.Value) === String(fieldValue))?.Text || fieldValue;
            } else if (selectedField === 'SourceName') {
                return sources.find(s => String(s.Value) === String(fieldValue))?.Text || fieldValue;
            } else if (selectedField === 'MediumName') {
                return mediums.find(m => String(m.Value) === String(fieldValue))?.Text || fieldValue;
            } else if (selectedField === 'CampaignName') {
                return campaigns.find(c => String(c.Value) === String(fieldValue))?.Text || fieldValue;
            } else if (selectedField === 'Owner') {
                return owners.find(o => String(o.Value || o.userid || o.UserId) === String(fieldValue))?.Text || owners.find(o => String(o.Value) === String(fieldValue))?.Name || fieldValue;
            } else if (selectedField === 'Stages' || selectedField === 'StagesId') {
                return stages.find(s => String(s.Value || s.Id) === String(fieldValue))?.Text || stages.find(s => String(s.Id) === String(fieldValue))?.Value || fieldValue;
            }
            return fieldValue;
        };

        const displayValue = displayValueMapping();

        const newUpdate = {
            Rowid: addedUpdates.length + 1,
            fieldID: fieldObj?.FieldID || fieldObj?.fieldID || selectedField,
            fieldName: fieldObj?.FieldName || fieldObj?.fieldName || selectedField,
            tableName: fieldObj?.TABLE_NAME || fieldObj?.tableName || "UserEnquiry",
            fieldType: fieldObj?.FieldType || fieldObj?.fieldType || "Pred",
            fieldValue: fieldValue,
            displayValue: displayValue,
            ids: isAllSelectedAcrossPages ? "" : (selectedEnquiries.join(',') || localStorage.getItem('hasid') || ""),
            ScheduleForUpdate: isScheduled ? scheduleDateTime : ""
        };

        setAddedUpdates([...addedUpdates, newUpdate]);
        setSelectedField('');
        setFieldValue('');
        setSelectedCountry('');
        setSelectedState('');
    };

    const handleRemoveUpdate = (rowid) => {
        setAddedUpdates(addedUpdates.filter(u => u.Rowid !== rowid));
    };

    const handleUpdateSave = async () => {
        if (addedUpdates.length === 0) {
            showAlert('error', 'Error', 'Please add at least one field to update');
            return;
        }

        if (isScheduled && !scheduleDateTime) {
            showAlert('error', 'Error', 'Please select a schedule date and time');
            return;
        }

        setIsLoading(true);
        try {
            const hashedIds = isAllSelectedAcrossPages ? "" : (selectedEnquiries.join(',') || localStorage.getItem('hasid') || "");

            let formattedScheduleDate = "";
            if (scheduleDateTime) {
                const date = new Date(scheduleDateTime);
                const day = date.getDate().toString().padStart(2, '0');
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const month = months[date.getMonth()];
                const year = date.getFullYear();
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                formattedScheduleDate = `${day}-${month}-${year} ${hours}:${minutes}`;
            }

            const payload = {
                Token: TOKEN || "-2295521862261168",
                Details: {
                    Module: "Enquiry",
                    Scheduledatetimelead: formattedScheduleDate,
                    Updatejson: JSON.stringify(addedUpdates.map(u => {
                        const { displayValue, ...rest } = u;
                        return {
                            ...rest,
                            ScheduleForUpdate: formattedScheduleDate
                        };
                    })),
                    UserId: Number(SESSION_USER_ID),
                    BatchId: "0",
                    HashedIds: hashedIds
                }
            };

            const response = await fetch(Mass_Update_Save, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                showAlert('success', 'Success', 'Mass update saved successfully', () => {
                    if (onSuccess) onSuccess();
                });
            } else {
                showAlert('error', 'Error', 'Failed to save mass update');
            }
        } catch (error) {
            console.error("Error saving mass update:", error);
            showAlert('error', 'Error', 'A network error occurred');
        } finally {
            setIsLoading(false);
        }
    };

    const showAlert = (type, title, message, onConfirm = null) => {
        setAlertConfig({
            show: true,
            type,
            title,
            message,
            onConfirm: () => {
                setAlertConfig(prev => ({ ...prev, show: false }));
                if (onConfirm) onConfirm();
            }
        });
    };

    const renderFieldValueInput = () => {
        const fieldObj = fields.find(f => f.FieldID === selectedField || f.FieldName === selectedField || f.fieldID === selectedField);

        if (!selectedField) return null;

        // Custom Fields with Choices
        if (fieldObj?.FieldType === 'Cust' && fieldObj?.FieldDetail) {
            try {
                const detail = JSON.parse(fieldObj.FieldDetail);
                const config = Array.isArray(detail) ? detail[0] : detail;
                if ((config.datatype === 's' || config.datatype === 'r') && config.choices) {
                    const options = config.choices.split(',').map(c => c.trim());
                    return (
                        <div className="input-group">
                            <label>Select {fieldObj.FieldName}</label>
                            <select
                                value={fieldValue}
                                onChange={(e) => setFieldValue(e.target.value)}
                                className="custom-select"
                            >
                                <option value="">Select Option</option>
                                {options.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
                            </select>
                        </div>
                    );
                }
                if (config.datatype === 'd') {
                    return (
                        <div className="input-group">
                            <label>Select Date</label>
                            <div className="custom-date-picker">
                                <Calendar size={18} className="calendar-icon" />
                                <input
                                    type="date"
                                    value={fieldValue}
                                    onChange={(e) => setFieldValue(e.target.value)}
                                    className="hidden-date-input"
                                />
                                <span className="date-display-text">
                                    {formatDateDisplay(fieldValue, false) || 'dd-MMM-yyyy'}
                                </span>
                            </div>
                        </div>
                    );
                }
            } catch (e) { console.error("Error parsing field detail:", e); }
        }

        // Predefined Fields with Dropdowns
        if (selectedField === 'Country') {
            return (
                <div className="input-group">
                    <label>Select Country</label>
                    <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select">
                        <option value="">Select Country</option>
                        {countries.map((c, i) => (
                            <option key={i} value={c.Id || c.Value}>
                                {c.Value || c.Text}
                            </option>
                        ))}
                    </select>
                </div>
            );
        }

        if (selectedField === 'State') {
            return (
                <>
                    <div className="input-group">
                        <label>Select Country</label>
                        <select value={selectedCountry} onChange={(e) => handleCountryChange(e.target.value)} className="custom-select">
                            <option value="">Select Country</option>
                            {countries.map((c, i) => (
                                <option key={i} value={c.Id || c.Value}>
                                    {c.Value || c.Text}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="input-group">
                        <label>Select State</label>
                        <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select" disabled={!selectedCountry}>
                            <option value="">Select State</option>
                            {states.map((s, i) => (
                                <option key={i} value={s.Id || s.Value}>
                                    {s.Value || s.Text}
                                </option>
                            ))}
                        </select>
                    </div>
                </>
            );
        }

        if (selectedField === 'City') {
            return (
                <>
                    <div className="input-group">
                        <label>Select Country</label>
                        <select value={selectedCountry} onChange={(e) => handleCountryChange(e.target.value)} className="custom-select">
                            <option value="">Select Country</option>
                            {countries.map((c, i) => (
                                <option key={i} value={c.Id || c.Value}>
                                    {c.Value || c.Text}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="input-group">
                        <label>Select State</label>
                        <select value={selectedState} onChange={(e) => handleStateChange(e.target.value)} className="custom-select" disabled={!selectedCountry}>
                            <option value="">Select State</option>
                            {states.map((s, i) => (
                                <option key={i} value={s.Id || s.Value}>
                                    {s.Value || s.Text}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="input-group">
                        <label>Select City</label>
                        <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select" disabled={!selectedState}>
                            <option value="">Select City</option>
                            {cities.map((c, i) => (
                                <option key={i} value={c.Id || c.Value}>
                                    {c.Value || c.Text}
                                </option>
                            ))}
                        </select>
                    </div>
                </>
            );
        }

        if (selectedField === 'SourceName') {
            return (
                <div className="input-group">
                    <label>Select Source</label>
                    <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select">
                        <option value="">Select Source</option>
                        {sources.map((s, i) => <option key={i} value={s.Value}>{s.Text}</option>)}
                    </select>
                </div>
            );
        }

        if (selectedField === 'MediumName') {
            return (
                <div className="input-group">
                    <label>Select Medium</label>
                    <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select">
                        <option value="">Select Medium</option>
                        {mediums.map((m, i) => <option key={i} value={m.Value}>{m.Text}</option>)}
                    </select>
                </div>
            );
        }

        if (selectedField === 'CampaignName') {
            return (
                <div className="input-group">
                    <label>Select Campaign</label>
                    <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select">
                        <option value="">Select Campaign</option>
                        {campaigns.map((c, i) => <option key={i} value={c.Value}>{c.Text}</option>)}
                    </select>
                </div>
            );
        }

        if (selectedField === 'Owner') {
            return (
                <div className="input-group">
                    <label>Select Owner</label>
                    <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select">
                        <option value="">Select Owner</option>
                        {owners.map((o, i) => (
                            <option key={i} value={o.Value || o.userid || o.UserId || o.Code}>
                                {o.Text || o.Name || o.UserName}
                            </option>
                        ))}
                    </select>
                </div>
            );
        }

        if (selectedField === 'Stages' || selectedField === 'StagesId') {
            return (
                <div className="input-group">
                    <label>Select Stage</label>
                    <select value={fieldValue} onChange={(e) => setFieldValue(e.target.value)} className="custom-select">
                        <option value="">Select Stage</option>
                        {stages.map((s, i) => {
                            const val = s.Value || s.Id || s.StageId || s.stageId || s.value;
                            const text = s.Text || s.Value || s.StageName || s.stageName || s.text;
                            return (
                                <option key={i} value={val}>
                                    {text}
                                </option>
                            );
                        })}
                    </select>
                </div>
            );
        }

        if (fieldObj?.FieldType === 'Pred' && (fieldObj?.FieldName === 'ReminderDate' || fieldObj?.fieldName === 'ReminderDate')) {
            return (
                <div className="input-group">
                    <label>Select Date</label>
                    <input
                        type="date"
                        value={fieldValue}
                        onChange={(e) => setFieldValue(e.target.value)}
                        className="custom-input"
                    />
                </div>
            );
        }

        // Default: Text input
        return (
            <div className="input-group">
                <label>Field Value</label>
                <input
                    type="text"
                    placeholder="Enter value"
                    value={fieldValue}
                    onChange={(e) => setFieldValue(e.target.value)}
                    className="custom-input"
                />
            </div>
        );
    };

    if (mode === 'update') {
        return (
            <div className="mass-operation-container">
                <div className="mass-update-header">
                    <h3>Mass Update Enquiry</h3>
                    {isLoading && <Loader size="small" />}
                </div>

                <div className="field-selection-area">
                    <div className="input-group">
                        <label>Select Field</label>
                        <div className="select-wrapper">
                            <select
                                value={selectedField}
                                onChange={(e) => {
                                    setSelectedField(e.target.value);
                                    setFieldValue('');
                                    setSelectedCountry('');
                                    setSelectedState('');
                                }}
                                className="custom-select"
                            >
                                <option value="">Please Select Field</option>
                                {fields.map((f, idx) => (
                                    <option key={idx} value={f.FieldID || f.fieldID || f.FieldName || f.fieldName}>
                                        {f.FieldName || f.fieldName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {renderFieldValueInput()}

                    <div className="flex justify-end mt-2">
                        <button className="add-btn" onClick={handleAddField}>
                            <Plus size={18} strokeWidth={3} /> Add
                        </button>
                    </div>
                </div>

                <div className="update-table-container">
                    <table className="update-table">
                        <thead>
                            <tr>
                                <th>Field Name</th>
                                <th>Field Value</th>
                                <th style={{ textAlign: 'center', width: '80px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {addedUpdates.length === 0 ? (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: 'center', padding: '32px', color: '#94a3b8', fontSize: '13px' }}>
                                        No fields added for update
                                    </td>
                                </tr>
                            ) : (
                                addedUpdates.map((update) => (
                                    <tr key={update.Rowid}>
                                        <td>{update.fieldName}</td>
                                        <td>{update.displayValue || update.fieldValue}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button
                                                className="remove-field-btn"
                                                onClick={() => handleRemoveUpdate(update.Rowid)}
                                                title="Remove field"
                                            >
                                                <Trash2 size={16} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mass-update-footer">
                    <div className="flex flex-col gap-2">
                        <label className="schedule-checkbox">
                            <input
                                type="checkbox"
                                checked={isScheduled}
                                onChange={(e) => setIsScheduled(e.target.checked)}
                            />
                            On Schedule Date And Time
                        </label>

                        {isScheduled && (
                            <div className="datetime-picker-container">
                                <div className="custom-date-picker">
                                    <Calendar size={18} className="calendar-icon" />
                                    <input
                                        type="datetime-local"
                                        value={scheduleDateTime}
                                        onChange={(e) => setScheduleDateTime(e.target.value)}
                                        className="hidden-date-input"
                                    />
                                    <span className="date-display-text">
                                        {formatDateDisplay(scheduleDateTime) || 'dd-MMM-yyyy HH:mm'}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>

                    <button
                        className="update-submit-btn"
                        onClick={handleUpdateSave}
                        disabled={addedUpdates.length === 0 || isLoading}
                    >
                        Update
                    </button>
                </div>

                {alertConfig.show && (
                    <Alert
                        show={true}
                        type={alertConfig.type}
                        title={alertConfig.title}
                        message={alertConfig.message}
                        onConfirm={alertConfig.onConfirm}
                        onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                    />
                )}
            </div>
        );
    }

    if (mode === 'marketing_sequence') {
        return (
            <div className="mass-operation-container">
                <div className="mass-update-header">
                    <h3>Marketing Sequence</h3>
                    {isLoading && <Loader size="small" />}
                </div>

                <div className="field-selection-area">
                    <div className="input-group">
                        <label>Select Sequence <span className="text-red-500">*</span></label>
                        <div className="select-wrapper">
                            <select
                                value={selectedSequence}
                                onChange={(e) => setSelectedSequence(e.target.value)}
                                className="custom-select"
                            >
                                <option value="">Please Select Sequence</option>
                                {sequences.map((s, idx) => (
                                    <option key={idx} value={s.SequenceID}>
                                        {s.SequenceName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="mt-4">
                        <label className="schedule-checkbox">
                            <input
                                type="checkbox"
                                checked={isScheduled}
                                onChange={(e) => setIsScheduled(e.target.checked)}
                            />
                            On Schedule Date And Time
                        </label>
                    </div>

                    {isScheduled && (
                        <div className="input-group mt-4">
                            <label>Schedule Date and Time <span className="text-red-500">*</span></label>
                            <div className="custom-date-picker">
                                <Calendar size={18} className="calendar-icon" />
                                <input
                                    type="datetime-local"
                                    value={scheduleDateTime}
                                    onChange={(e) => setScheduleDateTime(e.target.value)}
                                    className="hidden-date-input"
                                />
                                <span className="date-display-text">
                                    {formatDateDisplay(scheduleDateTime) || 'dd-MMM-yyyy HH:mm'}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="flex justify-end mt-6">
                        <button
                            className="save-sequence-btn"
                            onClick={handleSaveSequence}
                            disabled={isLoading}
                        >
                            Save Sequence
                        </button>
                    </div>
                </div>

                {alertConfig.show && (
                    <Alert
                        show={true}
                        type={alertConfig.type}
                        title={alertConfig.title}
                        message={alertConfig.message}
                        onConfirm={alertConfig.onConfirm}
                        onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                    />
                )}
            </div>
        );
    }

    if (mode === 'add_tag' || mode === 'remove_tag') {
        return (
            <div className="mass-operation-container">
                <div className="mass-update-header">
                    <h3>{mode === 'add_tag' ? 'Add Tag' : 'Remove Tag'}</h3>
                    {isLoading && <Loader size="small" />}
                </div>

                <div className="update-form-container">
                    <div className="form-group mb-6">
                        <label className="field-label">Select Tag <span className="text-red-500">*</span></label>
                        <div className="select-wrapper">
                            {!isCustomTag ? (
                                <select
                                    className="custom-select"
                                    value={selectedTag}
                                    onChange={(e) => {
                                        if (e.target.value === '___CUSTOM___') {
                                            setIsCustomTag(true);
                                            setSelectedTag('');
                                        } else {
                                            setSelectedTag(e.target.value);
                                        }
                                    }}
                                >
                                    <option value="">Nothing selected</option>
                                    {tags.map((tag, idx) => (
                                        <option key={idx} value={tag.TagWithID}>{tag.TagWithID}</option>
                                    ))}
                                    <option value="___CUSTOM___">+ Add New Tag...</option>
                                </select>
                            ) : (
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        className="custom-input"
                                        placeholder="Enter new tag name"
                                        value={selectedTag}
                                        onChange={(e) => setSelectedTag(e.target.value)}
                                        autoFocus
                                    />
                                    <button
                                        type="button"
                                        className="remove-field-btn"
                                        onClick={() => {
                                            setIsCustomTag(false);
                                            setSelectedTag('');
                                        }}
                                        title="Back to list"
                                        style={{ background: '#f1f5f9', color: '#64748b' }}
                                    >
                                        <ArrowLeft size={16} />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="form-group mb-6">
                        <div className="schedule-checkbox-container">
                            <label className="schedule-checkbox">
                                <input
                                    type="checkbox"
                                    checked={isScheduled}
                                    onChange={(e) => setIsScheduled(e.target.checked)}
                                />
                                <span className="checkbox-text">On Schedule Date And Time</span>
                            </label>
                        </div>

                        {isScheduled && (
                            <div className="mt-4">
                                <label className="field-label">Schedule Date and Time *</label>
                                <div className="custom-date-picker">
                                    <Calendar size={18} className="calendar-icon" />
                                    <input
                                        type="datetime-local"
                                        value={scheduleDateTime}
                                        onChange={(e) => setScheduleDateTime(e.target.value)}
                                        className="hidden-date-input"
                                    />
                                    <span className="date-display-text">
                                        {formatDateDisplay(scheduleDateTime) || 'dd-MMM-yyyy HH:mm'}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="flex justify-end mt-10">
                        <button
                            className="save-sequence-btn"
                            onClick={handleSaveTag}
                            disabled={isLoading || !selectedTag}
                        >
                            {mode === 'add_tag' ? 'Add Tag' : 'Remove Tag'}
                        </button>
                    </div>
                </div>

                {alertConfig.show && (
                    <Alert
                        show={true}
                        type={alertConfig.type}
                        title={alertConfig.title}
                        message={alertConfig.message}
                        onConfirm={alertConfig.onConfirm}
                        onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                    />
                )}
            </div>
        );
    }
    if (mode === 'add_call_list') {
        return (
            <div className="mass-operation-container">
                <div className="mass-update-header">
                    <h3>Add To Call List</h3>
                    {isLoading && <Loader size="small" />}
                </div>

                <div className="update-form-container">
                    <div className="form-group mb-6">
                        <label className="field-label">Call List<span className="text-red-500">*</span></label>
                        <div className="select-wrapper">
                            <select
                                className="custom-select"
                                value={selectedCallList}
                                onChange={(e) => setSelectedCallList(e.target.value)}
                            >
                                <option value="">Nothing selected</option>
                                {callLists.map((list, idx) => (
                                    <option key={idx} value={list.id}>{list.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="form-group mb-6">
                        <label className="field-label">Schedule Time<span className="text-red-500">*</span></label>
                        <div className="flex flex-wrap items-center gap-x-8 gap-y-6 mt-4">
                            <div className="flex items-center gap-4">
                                <label className="radio-label flex items-center gap-3 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="scheduleType"
                                        value="specific"
                                        checked={scheduleType === 'specific'}
                                        onChange={(e) => setScheduleType(e.target.value)}
                                        className="custom-radio"
                                    />
                                    <span className="text-sm text-gray-700 whitespace-nowrap">Specific Time</span>
                                </label>

                                <div className="custom-date-picker min-w-[220px]">
                                    <Calendar size={18} className="calendar-icon" />
                                    <input
                                        type="datetime-local"
                                        value={specificDateTime}
                                        onChange={(e) => setSpecificDateTime(e.target.value)}
                                        className="hidden-date-input"
                                        disabled={scheduleType !== 'specific'}
                                    />
                                    <span className={`date-display-text ${scheduleType !== 'specific' ? 'opacity-50' : ''}`}>
                                        {formatDateDisplay(specificDateTime) || 'dd-mm-yyyy --:--'}
                                    </span>
                                </div>
                            </div>

                            <label className="radio-label flex items-center gap-3 cursor-pointer">
                                <input
                                    type="radio"
                                    name="scheduleType"
                                    value="none"
                                    checked={scheduleType === 'none'}
                                    onChange={(e) => setScheduleType(e.target.value)}
                                    className="custom-radio"
                                />
                                <span className="text-sm text-gray-700 whitespace-nowrap">Without Date Time</span>
                            </label>

                            <div className="flex items-center gap-4">
                                <label className="radio-label flex items-center gap-3 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="scheduleType"
                                        value="anytime"
                                        checked={scheduleType === 'anytime'}
                                        onChange={(e) => setScheduleType(e.target.value)}
                                        className="custom-radio"
                                    />
                                    <span className="text-sm text-gray-700 whitespace-nowrap">Any Time On This Day</span>
                                </label>

                                <div className="custom-date-picker min-w-[200px]">
                                    <Calendar size={18} className="calendar-icon" />
                                    <input
                                        type="date"
                                        value={anyTimeDate}
                                        onChange={(e) => setAnyTimeDate(e.target.value)}
                                        className="hidden-date-input"
                                        disabled={scheduleType !== 'anytime'}
                                    />
                                    <span className={`date-display-text ${scheduleType !== 'anytime' ? 'opacity-50' : ''}`}>
                                        {formatDateDisplay(anyTimeDate, false) || 'Select Date'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end mt-10">
                        <button
                            className="save-sequence-btn !bg-[#8bc34a]"
                            onClick={handleSaveCallList}
                            disabled={isLoading || !selectedCallList}
                        >
                            Add Call List
                        </button>
                    </div>
                </div>

                {alertConfig.show && (
                    <Alert
                        show={true}
                        type={alertConfig.type}
                        title={alertConfig.title}
                        message={alertConfig.message}
                        onConfirm={alertConfig.onConfirm}
                        onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                    />
                )}
            </div>
        );
    }

    if (mode === 'add_followup') {
        const rawStatusValue = followupData.FollowupStatus.toString();
        const isNegative = rawStatusValue.split(',')[1] === '0';

        return (
            <div className="mass-operation-container">
                <div className="mass-update-header">
                    <h3>Add Followup</h3>
                    {isLoading && <Loader size="small" />}
                </div>

                <div className="update-form-container">
                    <div className="bg-blue-50 border-l-4 border-blue-500 px-4 py-3 mb-6 flex items-center justify-between">
                        <p className="text-sm text-blue-700">
                            <strong>Info!</strong> You are about to perform a mass action on {selectedEnquiries.length} selected record(s)
                        </p>
                    </div>

                    <div className="form-group mb-4">
                        <label className="field-label">Select Follow up<span className="text-red-500">*</span></label>
                        <select
                            name="FollowupStatus"
                            value={followupData.FollowupStatus}
                            onChange={handleFollowupChange}
                            className="custom-select"
                        >
                            <option value="">Select FollowupStatus</option>
                            {followupStatusOptions.map((opt, idx) => (
                                <option key={idx} value={opt.Value?.split(',')[0] || opt.Id || opt.Value || opt.Text}>{opt.Text || opt.Name}</option>
                            ))}
                        </select>
                    </div>

                    {!isNegative && (
                        <>
                            <div className="form-group mb-4">
                                <label className="field-label">Assign To</label>
                                <select
                                    name="AssignTo"
                                    value={followupData.AssignTo}
                                    onChange={handleFollowupChange}
                                    className="custom-select"
                                >
                                    {owners.map((opt) => (
                                        <option key={opt.Id || opt.Code} value={opt.Id || opt.Code}>{opt.Text || opt.Name || opt.UserName}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div className="form-group mb-4">
                                    <label className="field-label">Next Status Date</label>
                                    <div className="custom-date-picker">
                                        <Calendar size={18} className="calendar-icon" />
                                        <input
                                            type="date"
                                            name="NextStatusDate"
                                            value={followupData.NextStatusDate}
                                            min={new Date().toISOString().split('T')[0]}
                                            onChange={handleFollowupChange}
                                            className="hidden-date-input"
                                        />
                                        <span className="date-display-text">
                                            {formatDateDisplay(followupData.NextStatusDate, false) || 'dd-mm-yyyy'}
                                        </span>
                                    </div>
                                </div>

                                <div className="form-group mb-4">
                                    <label className="field-label">Next Status Time</label>
                                    <div className="relative">
                                        <input
                                            type="time"
                                            name="NextStatusTime"
                                            value={followupData.NextStatusTime}
                                            onChange={handleFollowupChange}
                                            className="custom-input"
                                        />
                                        <Clock className="absolute right-3 top-2.5 w-5 h-5 text-gray-400 pointer-events-none" />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div className="form-group mb-4">
                        <label className="field-label">Remarks</label>
                        <textarea
                            name="Remarks"
                            value={followupData.Remarks}
                            onChange={handleFollowupChange}
                            placeholder="Remarks"
                            rows="3"
                            className="custom-textarea"
                        />
                    </div>

                    {!isNegative && (
                        <>
                            <div className="form-group mb-4 relative">
                                <label className="field-label">Products</label>
                                <div className="flex flex-wrap gap-2 mb-2">
                                    {selectedLocalProducts.map((p) => (
                                        <div key={p.Value} className="flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-700 text-sm font-medium rounded-lg border border-blue-100 shadow-sm transition-all hover:bg-blue-100 group">
                                            <span>{p.Text}</span>
                                            <button
                                                onClick={() => handleRemoveProduct(p.Value)}
                                                className="p-0.5 hover:bg-blue-200 rounded-full text-blue-400 hover:text-blue-600 transition-colors"
                                            >
                                                <X size={14} />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <div className="relative z-[100]">
                                    <input
                                        type="text"
                                        value={productSearchTerm}
                                        onChange={(e) => handleProductSearch(e.target.value)}
                                        onFocus={() => { if (suggestedProducts.length > 0) setShowProductDropdown(true); }}
                                        placeholder={selectedLocalProducts.length > 0 ? "Add another product..." : "Search and select products..."}
                                        className="custom-input pl-10"
                                        autoComplete="off"
                                    />
                                    <Plus size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                </div>
                                {showProductDropdown && suggestedProducts.length > 0 && (
                                    <div className="absolute z-[100] w-full mt-2 bg-white border border-gray-200 rounded-xl shadow-xl max-h-64 overflow-y-auto animate-in fade-in slide-in-from-top-2 duration-200">
                                        {suggestedProducts.map((p) => (
                                            <div
                                                key={p.Value || p.ProductID || p.Id || p.id}
                                                className="flex items-center gap-3 p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-50 last:border-0 transition-colors"
                                                onClick={() => handleSelectProduct(p)}
                                            >
                                                <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden border border-gray-100 flex-shrink-0">
                                                    <img
                                                        src={p.Image || 'https://via.placeholder.com/40?text=No+Img'}
                                                        alt={p.Text || p.Name}
                                                        className="w-full h-full object-cover"
                                                        onError={(e) => { e.target.src = 'https://via.placeholder.com/40?text=No+Img'; e.target.onerror = null; }}
                                                    />
                                                </div>
                                                <div className="flex flex-col min-w-0">
                                                    <span className="text-sm font-semibold text-gray-900 truncate">{p.Text || p.Name}</span>
                                                    <span className="text-xs text-gray-500">Price: {p.Price || 'N/A'}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="flex flex-col gap-4 mt-6">
                                <label className="checkbox-item flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="IsReassign"
                                        checked={followupData.IsReassign}
                                        onChange={handleFollowupChange}
                                        className="w-4 h-4"
                                    />
                                    <span className="text-sm font-semibold text-gray-700">Re-Assign</span>
                                </label>

                                <div className="on-schedule-container mt-2">
                                    {followupData.OnSchedule && (
                                        <div className="form-group mb-4">
                                            <label className="field-label">Saveon Schedule Date and Time*</label>
                                            <div className="custom-date-picker">
                                                <Calendar size={18} className="calendar-icon" />
                                                <input
                                                    type="datetime-local"
                                                    name="ScheduleDateTime"
                                                    value={followupData.ScheduleDateTime}
                                                    min={new Date().toISOString().slice(0, 16)}
                                                    onChange={(e) => setFollowupData(prev => ({ ...prev, ScheduleDateTime: e.target.value }))}
                                                    className="hidden-date-input"
                                                />
                                                <span className="date-display-text">
                                                    {formatDateDisplay(followupData.ScheduleDateTime) || 'dd-MMM-yyyy HH:mm'}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                    <label className="checkbox-item flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="checkbox"
                                            name="OnSchedule"
                                            checked={followupData.OnSchedule}
                                            onChange={handleFollowupChange}
                                            className="w-4 h-4 accent-red-600"
                                        />
                                        <span className="text-sm text-gray-700">On Schedule Date And Time</span>
                                    </label>
                                </div>
                            </div>
                        </>
                    )}

                    <div className="flex justify-end mt-10">
                        <button
                            className="save-sequence-btn !bg-[#8bc34a]"
                            onClick={handleSaveMassFollowup}
                            disabled={isLoading || !followupData.FollowupStatus}
                        >
                            Save Followup
                        </button>
                    </div>
                </div>

                {alertConfig.show && (
                    <Alert
                        show={true}
                        type={alertConfig.type}
                        title={alertConfig.title}
                        message={alertConfig.message}
                        onConfirm={alertConfig.onConfirm}
                        onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                    />
                )}
            </div>
        );
    }

    if (mode === 'sms') {
        return (
            <div className="mass-operation-container">
                <div className="mass-update-header">
                    <h3>Send SMS</h3>
                    {isLoading && <Loader size="small" />}
                </div>

                <div className="update-form-container">
                    <div className="bg-blue-50 border-l-4 border-blue-500 px-4 py-3 mb-6 flex items-center justify-between">
                        <p className="text-sm text-blue-700">
                            <strong>Info!</strong> You are about to perform a mass action on {selectedEnquiries.length} selected record(s)
                        </p>
                    </div>

                    <div className="border-b border-gray-100 pb-4 mb-4">
                        <div className="flex items-center justify-between">
                            <p className="text-xs text-gray-500 italic">Only DLT registered entities can send SMS. To know more <a href="#" className="text-blue-500 underline ml-1">Click here !</a></p>
                        </div>
                    </div>

                    <div className="mb-4 flex items-center gap-6">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="Mobile1"
                                checked={sendSmsData.Mobile1}
                                onChange={handleSmsChange}
                                className="w-4 h-4 rounded border-gray-300 text-blue-600"
                            />
                            <span className="text-sm text-gray-700">Mobile1</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="Mobile2"
                                checked={sendSmsData.Mobile2}
                                onChange={handleSmsChange}
                                className="w-4 h-4 rounded border-gray-300 text-blue-600"
                            />
                            <span className="text-sm text-gray-700">Mobile2</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="Mobile3"
                                checked={sendSmsData.Mobile3}
                                onChange={handleSmsChange}
                                className="w-4 h-4 rounded border-gray-300 text-blue-600"
                            />
                            <span className="text-sm text-gray-700">Mobile3</span>
                        </label>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="form-group mb-4">
                            <label className="field-label">Account <span className="text-red-500">*</span></label>
                            <select
                                name="Account"
                                value={sendSmsData.Account}
                                onChange={handleSmsChange}
                                className="custom-select"
                            >
                                <option value="">Select Account</option>
                                {smsAccounts.map((acc, i) => <option key={i} value={acc.AccountId || acc.Code}>{acc.AccountName || acc.Text}</option>)}
                            </select>
                        </div>
                        <div className="form-group mb-4">
                            <label className="field-label">Sender ID <span className="text-red-500">*</span></label>
                            <select
                                name="SenderId"
                                value={sendSmsData.SenderId}
                                onChange={handleSmsChange}
                                className="custom-select"
                            >
                                <option value="">Select Sender ID</option>
                                {smsSenderIds.map((s, i) => <option key={i} value={s.SenderName}>{s.SenderName}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="form-group mb-4">
                            <label className="field-label">Template</label>
                            <select
                                name="TemplateId"
                                value={sendSmsData.TemplateId}
                                onChange={(e) => {
                                    const tid = e.target.value;
                                    const template = smsTemplates.find(t => (t.MailTemplateId || t.Id).toString() === tid);
                                    setSendSmsData(prev => ({
                                        ...prev,
                                        TemplateId: tid,
                                        Message: template ? (template.MailTemplateContent || template.Content) : prev.Message
                                    }));
                                }}
                                className="custom-select"
                            >
                                <option value="">Select Template</option>
                                {smsTemplates.map((t, i) => <option key={i} value={t.MailTemplateId || t.Id}>{t.MailTemplateName || t.Name}</option>)}
                            </select>
                        </div>
                        <div className="flex items-center pt-6">
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="IsUnicode"
                                    checked={sendSmsData.IsUnicode}
                                    onChange={handleSmsChange}
                                    className="w-4 h-4 rounded border-gray-300 text-blue-600"
                                />
                                <span className="text-sm text-gray-700">IsUnicode</span>
                            </label>
                        </div>
                    </div>

                    <div className="form-group mb-4">
                        <label className="field-label">Message <span className="text-red-500">*</span></label>
                        <textarea
                            name="Message"
                            value={sendSmsData.Message}
                            onChange={handleSmsChange}
                            placeholder="Message"
                            rows="5"
                            className="custom-textarea"
                        />
                    </div>

                    <div className="mb-6">
                        <div className="flex items-center gap-6 mb-4">
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="TrackUrl"
                                    checked={sendSmsData.TrackUrl}
                                    onChange={handleSmsChange}
                                    className="w-4 h-4 rounded border-gray-300 text-blue-600"
                                />
                                <span className="text-sm text-gray-700">Track Url</span>
                            </label>
                            <label
                                className={`flex items-center gap-2 ${sendSmsData.TrackUrl ? 'cursor-pointer text-blue-600' : 'cursor-not-allowed text-gray-400'}`}
                                onClick={() => {
                                    if (sendSmsData.TrackUrl) setShowTrackDetails(!showTrackDetails);
                                }}
                            >
                                <Send size={16} />
                                <span className="text-sm font-medium">Track SMS</span>
                            </label>
                        </div>

                        {sendSmsData.TrackUrl && (
                            <TrackSMSModal
                                isOpen={showTrackDetails}
                                onClose={() => setShowTrackDetails(false)}
                                trackForm={trackForm}
                                handleTrackFormChange={handleTrackFormChange}
                                shortUrls={shortUrls}
                                messagePreview={sendSmsData.Message}
                                onAdd={handleAddTrackUrl}
                            />
                        )}
                    </div>

                    <div className="on-schedule-container border-t border-gray-100 pt-6">
                        {sendSmsData.OnSchedule && (
                            <div className="form-group mb-4">
                                <label className="field-label">SendSMS on Schedule Date and Time<span className="text-red-500">*</span></label>
                                <div className="custom-date-picker">
                                    <Calendar size={18} className="calendar-icon" />
                                    <input
                                        type="datetime-local"
                                        name="ScheduleDateTime"
                                        value={sendSmsData.ScheduleDateTime}
                                        min={new Date().toISOString().slice(0, 16)}
                                        onChange={handleSmsChange}
                                        className="hidden-date-input"
                                    />
                                    <span className="date-display-text">
                                        {formatDateDisplay(sendSmsData.ScheduleDateTime) || 'dd-MMM-yyyy HH:mm'}
                                    </span>
                                </div>
                            </div>
                        )}
                        <label className="checkbox-item flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="OnSchedule"
                                checked={sendSmsData.OnSchedule}
                                onChange={handleSmsChange}
                                className="w-4 h-4"
                            />
                            <span className="text-sm text-gray-700">On Schedule Date And Time</span>
                        </label>
                    </div>

                    <div className="flex justify-end mt-10">
                        <button
                            className="save-sequence-btn !bg-[#8bc34a]"
                            onClick={handleSendMassSms}
                            disabled={isLoading || !sendSmsData.Account || !sendSmsData.SenderId || !sendSmsData.Message}
                        >
                            Send SMS
                        </button>
                    </div>
                </div>

                {alertConfig.show && (
                    <Alert
                        show={true}
                        type={alertConfig.type}
                        title={alertConfig.title}
                        message={alertConfig.message}
                        onConfirm={alertConfig.onConfirm}
                        onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                    />
                )}
            </div>
        );
    }

    if (mode === 'mail') {
        return (
            <div className="mass-operation-container">
                <div className="mass-update-header">
                    <h3>Send Mail</h3>
                    {isLoading && <Loader size="small" />}
                </div>

                <div className="update-form-container">
                    <div className="bg-blue-50 border-l-4 border-blue-500 px-4 py-3 mb-6 flex items-center justify-between">
                        <p className="text-sm text-blue-700">
                            <strong>Info!</strong> You are about to perform a mass action on {selectedEnquiries.length} selected record(s)
                        </p>
                    </div>

                    <div className="mb-6 flex items-center gap-6">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="Email1"
                                checked={sendMailData.Email1}
                                onChange={handleMailChange}
                                className="w-4 h-4 rounded border-gray-300 text-red-600 accent-red-600"
                            />
                            <span className="text-sm text-gray-700">Email1</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="Email2"
                                checked={sendMailData.Email2}
                                onChange={handleMailChange}
                                className="w-4 h-4 rounded border-gray-300 text-red-600 accent-red-600"
                            />
                            <span className="text-sm text-gray-700">Email2</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="Email3"
                                checked={sendMailData.Email3}
                                onChange={handleMailChange}
                                className="w-4 h-4 rounded border-gray-300 text-red-600 accent-red-600"
                            />
                            <span className="text-sm text-gray-700">Email3</span>
                        </label>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mb-6">
                        <div className="form-group">
                            <input
                                type="text"
                                name="SenderName"
                                value={sendMailData.SenderName}
                                onChange={handleMailChange}
                                placeholder="Sender Name"
                                className="custom-input"
                            />
                        </div>
                        <div className="form-group">
                            <select
                                name="Account"
                                value={sendMailData.Account}
                                onChange={handleMailChange}
                                className="custom-select"
                            >
                                <option value="">Select Account</option>
                                {mailAccounts.map((acc, i) => <option key={i} value={acc.AccountId || acc.Code}>{acc.AccountName || acc.Text}</option>)}
                            </select>
                        </div>
                        <div className="form-group">
                            <select
                                name="From"
                                value={sendMailData.From}
                                onChange={handleMailChange}
                                className="custom-select"
                            >
                                <option value="">Select From Mail</option>
                                {fromMailOptions.map((opt, i) => <option key={i} value={opt.Value}>{opt.Text}</option>)}
                            </select>
                        </div>
                        <div className="form-group">
                            <select
                                name="ReplyTo"
                                value={sendMailData.ReplyTo}
                                onChange={handleMailChange}
                                className="custom-select"
                            >
                                <option value="">Select Reply To</option>
                                {fromMailOptions.map((opt, i) => <option key={i} value={opt.Value}>{opt.Text}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="flex items-center justify-center gap-12 mb-8">
                        <label className="flex flex-col items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                name="MailMode"
                                value="template"
                                checked={sendMailData.MailMode === 'template'}
                                onChange={handleMailChange}
                                className="w-5 h-5 accent-red-600"
                            />
                            <span className="text-sm font-medium text-gray-700">Select Template</span>
                        </label>
                        <label className="flex flex-col items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                name="MailMode"
                                value="compose"
                                checked={sendMailData.MailMode === 'compose'}
                                onChange={handleMailChange}
                                className="w-5 h-5 accent-red-600"
                            />
                            <span className="text-sm font-medium text-gray-700">Compose Mail</span>
                        </label>
                    </div>

                    <div className="form-group mb-6">
                        <div className="flex items-center gap-2">
                            <input
                                type="text"
                                name="Subject"
                                value={sendMailData.Subject}
                                onChange={handleMailChange}
                                placeholder="Subject"
                                className="custom-input flex-1"
                            />
                            <button className="p-2 border border-gray-200 rounded-lg bg-gray-50 hover:bg-gray-100">
                                <Tag size={20} className="text-gray-500" />
                            </button>
                        </div>
                    </div>

                    {sendMailData.MailMode === 'template' ? (
                        <div className="form-group mb-6">
                            <label className="text-xs text-gray-500 mb-2 block flex justify-between items-center">
                                <span>or Select Template :</span>
                                <span
                                    className={`text-blue-500 underline cursor-pointer hover:text-blue-700 transition-colors ${!sendMailData.TemplateId ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    onClick={() => sendMailData.TemplateId && setShowMailPreview(true)}
                                >
                                    Click To View
                                </span>
                            </label>
                            <select
                                name="TemplateId"
                                value={sendMailData.TemplateId}
                                className="custom-select"
                                onChange={(e) => {
                                    const tid = e.target.value;
                                    const template = mailTemplates.find(t => (t.MailTemplateId || t.Id).toString() === tid);
                                    if (template) {
                                        setSendMailData(prev => ({
                                            ...prev,
                                            TemplateId: tid,
                                            TemplateName: template.MailTemplateName || template.Name || '',
                                            Subject: template.MailTemplateSubject || template.Subject || prev.Subject,
                                            Body: template.MailTemplateContent || template.Content
                                        }));
                                        // Show preview when a template is selected
                                        setShowMailPreview(true);
                                    } else {
                                        setSendMailData(prev => ({ ...prev, TemplateId: '', TemplateName: '', Body: '' }));
                                    }
                                }}
                            >
                                <option value="">-- None --</option>
                                {mailTemplates.map((t, i) => (
                                    <option key={i} value={t.MailTemplateId || t.Id}>{t.MailTemplateName || t.Name} ( Enquiry )</option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        <div className="form-group mb-6">
                            <div className="quill-editor-wrap">
                                <SafeQuill
                                    theme="snow"
                                    value={sendMailData.Body}
                                    onChange={(content) => setSendMailData(prev => ({ ...prev, Body: content }))}
                                    modules={quillModules}
                                    placeholder="Compose your mail here..."
                                    className="bg-white rounded-lg"
                                />
                            </div>
                        </div>
                    )}

                    {/* Mail Preview Modal */}
                    {showMailPreview && (
                        <MailPreviewModal
                            isOpen={showMailPreview}
                            onClose={() => setShowMailPreview(false)}
                            content={sendMailData.Body}
                            subject={sendMailData.Subject}
                        />
                    )}

                    <div className="flex items-center justify-between border-t border-gray-100 pt-6">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                name="OnSchedule"
                                checked={sendMailData.OnSchedule}
                                onChange={handleMailChange}
                                className="w-4 h-4 rounded border-gray-300 text-blue-600"
                            />
                            <span className="text-sm text-gray-700 font-medium">On Schedule Date And Time</span>
                        </label>

                        <button
                            className="px-8 py-2.5 bg-[#8bc34a] text-white rounded shadow-sm hover:bg-[#7cb342] transition-colors font-medium flex items-center gap-2"
                            onClick={handleSendMassMail}
                            disabled={isLoading}
                        >
                            <Mail size={18} />
                            Send Mail
                        </button>
                    </div>

                    {sendMailData.OnSchedule && (
                        <div className="mt-4 animate-in slide-in-from-top-2">
                            <input
                                type="datetime-local"
                                name="ScheduleDateTime"
                                value={sendMailData.ScheduleDateTime}
                                onChange={handleMailChange}
                                className="custom-input !w-auto"
                            />
                        </div>
                    )}
                </div>

                {alertConfig.show && (
                    <Alert
                        show={true}
                        type={alertConfig.type}
                        title={alertConfig.title}
                        message={alertConfig.message}
                        onConfirm={alertConfig.onConfirm}
                        onCancel={() => setAlertConfig(prev => ({ ...prev, show: false }))}
                    />
                )}
            </div>
        );
    }


    if (mode === 'international_sms') {
        return (
            <InternationalSMSForm
                selectedEnquiries={selectedEnquiries}
                isAllSelectedAcrossPages={isAllSelectedAcrossPages}
                totalRecord={totalRecord}
                onClose={onBack}
                onSuccess={onSuccess}
            />
        );
    }

    // Default: use EnquiryActionOperation for other modes (mail, sms, etc.)
    return (
        <EnquiryActionOperation
            entity={isAllSelectedAcrossPages ? { enquiryId: "0" } : {}}
            selectedEnquiries={selectedEnquiries}
            isAllSelectedAcrossPages={isAllSelectedAcrossPages}
            totalRecord={totalRecord}
            mode={mode}
            onBack={onBack}
            onSuccess={onSuccess}
        />
    );
};

const TrackSMSModal = ({ isOpen, onClose, trackForm, handleTrackFormChange, shortUrls, messagePreview, onAdd }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200">
                {/* Header */}
                <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
                    <h3 className="text-lg font-bold text-gray-900">Track SMS Configuration</h3>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors">
                        <X className="w-5 h-5 text-gray-500" />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-6 space-y-6">
                    <div className="space-y-4">
                        <div className="form-group">
                            <label className="field-label">Domain</label>
                            <select
                                name="Domain"
                                value={trackForm.Domain}
                                onChange={handleTrackFormChange}
                                className="custom-select"
                            >
                                <option value="">Select a Short Url</option>
                                {shortUrls.map((s, i) => (
                                    <option key={i} value={s.shorturl}>{s.shorturl}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="field-label">Track URL (Required)</label>
                            <input
                                type="text"
                                name="TrackUrl"
                                value={trackForm.TrackUrl}
                                onChange={handleTrackFormChange}
                                placeholder="Url (Required)"
                                className="custom-input"
                            />
                        </div>

                        <div className="form-group">
                            <label className="field-label">Select Action</label>
                            <select
                                name="Action"
                                value={trackForm.Action}
                                onChange={handleTrackFormChange}
                                className="custom-select"
                            >
                                <option value="original">Original Url</option>
                                <option value="call">Click to Call</option>
                                <option value="email">Click to Email</option>
                                <option value="whatsapp">Click to WhatsApp</option>
                            </select>
                        </div>

                        {trackForm.Action === 'call' && (
                            <div className="form-group animate-in slide-in-from-top-2 duration-200">
                                <label className="field-label">Mobile No</label>
                                <input
                                    type="text"
                                    name="MobileNo"
                                    value={trackForm.MobileNo}
                                    onChange={handleTrackFormChange}
                                    placeholder="Mobile No to Call"
                                    className="custom-input"
                                />
                            </div>
                        )}

                        {trackForm.Action === 'email' && (
                            <div className="space-y-4 animate-in slide-in-from-top-2 duration-200">
                                <div className="form-group">
                                    <label className="field-label">Email Id</label>
                                    <input
                                        type="email"
                                        name="EmailId"
                                        value={trackForm.EmailId}
                                        onChange={handleTrackFormChange}
                                        placeholder="Email Id"
                                        className="custom-input"
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="field-label">Subject</label>
                                    <input
                                        type="text"
                                        name="Subject"
                                        value={trackForm.Subject}
                                        onChange={handleTrackFormChange}
                                        placeholder="Email Subject"
                                        className="custom-input"
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="field-label">Body</label>
                                    <textarea
                                        name="Body"
                                        value={trackForm.Body}
                                        onChange={handleTrackFormChange}
                                        placeholder="Email Body"
                                        rows="3"
                                        className="custom-textarea"
                                    />
                                </div>
                            </div>
                        )}

                        {trackForm.Action === 'whatsapp' && (
                            <div className="space-y-4 animate-in slide-in-from-top-2 duration-200">
                                <div className="form-group">
                                    <label className="field-label">WhatsApp No</label>
                                    <input
                                        type="text"
                                        name="WhatsappNo"
                                        value={trackForm.WhatsappNo}
                                        onChange={handleTrackFormChange}
                                        placeholder="WhatsApp No with country code"
                                        className="custom-input"
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="field-label">Message</label>
                                    <textarea
                                        name="Message"
                                        value={trackForm.Message}
                                        onChange={handleTrackFormChange}
                                        placeholder="Text Message"
                                        rows="3"
                                        className="custom-textarea"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-4 border-t border-gray-100 flex items-center justify-end gap-3 bg-gray-50">
                    <button
                        onClick={onClose}
                        className="px-5 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-white font-medium transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onAdd}
                        className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-all shadow-sm hover:shadow-md active:scale-95 flex items-center gap-2"
                    >
                        <Plus size={18} />
                        <span>Insert Link Action</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

const MailPreviewModal = ({ isOpen, onClose, content, subject }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-300">
                {/* Header */}
                <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-white sticky top-0 z-10">
                    <div>
                        <h3 className="text-lg font-bold text-gray-900">Email Template Preview</h3>
                        <p className="text-sm text-gray-500 truncate max-w-md">Subject: {subject}</p>
                    </div>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors">
                        <X className="w-5 h-5 text-gray-500" />
                    </button>
                </div>

                {/* Content Area */}
                <div className="flex-1 overflow-auto bg-gray-50 p-4 sm:p-8">
                    <div className="bg-white shadow-lg rounded-lg mx-auto max-w-[800px] overflow-hidden min-h-[400px]">
                        {/* We use an iframe to safely render the HTML content without affecting the main app styles */}
                        <iframe
                            title="Template Preview"
                            srcDoc={content}
                            className="w-full h-[60vh] border-none"
                            sandbox="allow-popups allow-popups-to-escape-sandbox"
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-4 border-t border-gray-100 flex justify-end bg-gray-50">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-all font-medium"
                    >
                        Close Preview
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EnquiryMassoperation;
